module.exports = __webpack_public_path__ + "static/img/empower.44ae3cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/empower.png
// module id = +9MA
// module chunks = 0